
import { Vue, Component, Prop, Emit, Watch } from 'vue-property-decorator';
import { types } from '../../api_types';
import T from '../../lang';
import { Tab } from '../problem/Details.vue';

@Component
export default class Arena extends Vue {
  @Prop({ default: false }) shouldShowRuns!: boolean;
  @Prop({ default: true }) shouldShowRanking!: boolean;
  @Prop({ default: () => [] }) clarifications!: types.Clarification[];
  @Prop() title!: string;
  @Prop() activeTab!: string;
  @Prop() backgroundClass!: string;

  T = T;
  selectedTab = this.activeTab;
  clarificationsHaveBeenRead = false;

  get unreadClarifications() {
    return (
      this.activeTab !== 'clarifications' && !this.clarificationsHaveBeenRead
    );
  }

  get availableTabs(): Tab[] {
    const tabs = [
      {
        name: 'problems',
        text: T.wordsProblems,
        visible: true,
      },
      {
        name: 'ranking',
        text: T.wordsRanking,
        visible: this.shouldShowRanking,
      },
      {
        name: 'runs',
        text: T.wordsRuns,
        visible: this.shouldShowRuns,
      },
      {
        name: 'clarifications',
        text: T.wordsClarifications,
        visible: true,
      },
    ];
    return tabs.filter((tab) => tab.visible);
  }

  @Watch('activeTab')
  onActiveTabChanged(newTab: string) {
    this.selectedTab = newTab;
  }

  @Emit('update:activeTab')
  onTabSelected(tabName: string): string {
    if (tabName === 'clarifications') {
      this.clarificationsHaveBeenRead = true;
    }
    this.selectedTab = tabName;
    return this.selectedTab;
  }
}
